import { PrismaClient } from '@prisma/client';
import { getServerRuntimeConfig } from '../../common/config';

export { Prisma } from '@prisma/client';

export const prismaErrorCodes = {
  UNIQUE_CONSTRAINT_FAILED: 'P2002',
};

function createPrismaClient() {
  const { prismaLogOptions } = getServerRuntimeConfig();
  return new PrismaClient({ log: prismaLogOptions });
}

function getGlobalPrismaClient(): ReturnType<typeof createPrismaClient> {
  // @ts-ignore
  if (!global.prisma) {
    // @ts-ignore
    global.prisma = createPrismaClient();
  }
  // @ts-ignore
  return global.prisma;
}

const prisma = (() => {
  if (process.env.NODE_ENV === 'production') {
    return createPrismaClient();
  } else {
    return getGlobalPrismaClient();
  }
})();

export default prisma;
